import { render, staticRenderFns } from "./CrudDataTable.vue?vue&type=template&id=df6ffd8c&scoped=true&lang=pug&"
import script from "./CrudDataTable.vue?vue&type=script&lang=js&"
export * from "./CrudDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CrudDataTable.vue?vue&type=style&index=0&id=df6ffd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6ffd8c",
  null
  
)

component.options.__file = "CrudDataTable.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCheckbox,
  VDataTable,
  VIcon,
  VLayout,
  VTextField,
})
